import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams({ palavra: "", voz: "" }, location)
  );
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (dados.palavra || dados.voz) {
      listarPronuncias();
    }
  }, []);

  const listarPronuncias = (filtrosEnviar = dados) => {
    setCarregando(true);

    setDados(filtrosEnviar);
    api
      .get("pronuncias/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((e) => {
        alert("Erro ao listar as pronúncias: " + e);
      });
  };

  const filtros = {
    title: "Filtrar",
    form: {
      palavra: {
        label: "Palavra",
        type: "text",
        value: dados.palavra,
        space: 6,
      },
      voz: {
        type: "select",
        label: "Voz",
        emptyItem: true,
        emptyItemText: "(Todas)",
        value: dados.voz,
        space: 6,
        options: [
          {
            value: "",
            desc: "(Todas)",
          },
          {
            value: "F",
            desc: "Feminina",
          },
          {
            value: "M",
            desc: "Masculina",
          },
        ],
      },
    },

    submit: {
      label: "Buscar",
      action: listarPronuncias,
    },
    urlParams: true,
    history,
    location,
  };

  const abrirPronuncia = (registro) => {
    history.push(`/app/pronuncia/${registro.id}`);
  };

  const tRegistros = {
    title: "Pronúncias",
    onLineClick: abrirPronuncia,
    columns: [
      {
        name: "palavra",
        label: "Palavra",
        type: "text",
      },
      {
        name: "descricao",
        label: "Descrição",
        type: "text",
      },
      {
        name: "voz",
        label: "Voz",
      },
      {
        name: "ativa",
        label: "Ativa",
        checkbox: true,
      },
    ],
    array: lista,
    newItemAction: () => history.push("/app/pronuncia/0"),
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
